import React from 'react';

export const hoursToIntForSort = (hourStr) => {
  const intArray = (hourStr.replace(/\(|\)/g, '')).split(' '); // Hours format: (day) hour
  // Each day is 24 hours so turn this plus the actual real hours to sort properly.
  return (parseInt(intArray[0], 0) * 24) + parseInt(intArray[1], 0);
};

export const makeTableColumn = ({ categories }) => {
  // Define the set width of columns based on length of chartData.
  const keys = Object.keys(categories);
  const width = `${100 / (keys.length + 1)}%`;
  const sortFunc = context => (a, b) => {
    const ac = a[context];
    const bc = b[context];

    if (
      typeof ac === 'number'
      || typeof bc === 'number'
    ) {
      return ac - bc;
    }

    if (context === 'Hour') { // Hours in week is in this format: (day) hour
      return hoursToIntForSort(ac) - hoursToIntForSort(bc);
    }

    const aStr = ac || '';
    const bStr = bc || '';
    return aStr.localeCompare(bStr);
  };

  return keys.map((key) => {
    const { header, sortable = true, filter = true } = categories[key];

    return ({
      title: header || key,
      dataIndex: key,
      width,
      sorter: sortable ? sortFunc(key) : false,
      filters: filter,
      render: text => <span>{text}</span>,
    });
  });
};
